import firebase from 'firebase/app';

export const archiveQueries = ({ auth, profile }) => {
  var today = new Date();
  var start = new Date(
    today.getFullYear(),
    today.getMonth() - 6,
    today.getDate()
  );

  const cutoffDate = new Date('2024-01-01');



  if (
    profile.role === 'manager' ||
    profile.role === 'agent' ||
    profile.role === 'temp-agent'
  ) {
    return [
      {
        collection: 'complaints',
        where: [
          ['status', 'in', ['closed', 'cancelled']],
          ['created', '>=', new Date('2023-01-01')]
        ],
        orderBy: [['created', 'desc']],
        storeAs: 'complaints',
      },
    ];
  } else {
    return [];
  }
};

export const searchQueries = ({ auth, profile }) => {
  const start = new Date(new Date().getFullYear(), 0, 1);
  const end = new Date(new Date().getFullYear(), 12, 31);

  // var query = firebase.firestore().collection('complaints');
  // query = query.where('status', 'in', [['open', 'processing', 'ovedue']]);
  // if (profile.role === 'agent' || profile.role === 'temp-agent') {
  //   query = query.where('agent.uid', '==', profile.uid);
  // }
  // query = query.limit(100);

  // query.get().then((data) => {
  //   return data.docs;
  // });

  if (
    profile.role === 'manager' ||
    profile.role === 'agent' ||
    profile.role === 'temp-agent'
  ) {
    return [
      {
        collection: 'complaints',
        where: ['status', 'in', ['open', 'processing', 'overdue']],
        orderBy: ['created', 'desc'],
        limit: 1500,
        storeAs: 'complaints',
      },
    ];
  } else {
    return [];
  }
};
